"use strict";

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var CodeMirror = require("codemirror");
window["jsonlint"] = require('jsonlint-mod/web/jsonlint');
// Modes
require("codemirror/mode/htmlmixed/htmlmixed");
require("codemirror/mode/xml/xml");
require("codemirror/mode/javascript/javascript");
require("codemirror/mode/clike/clike");
require("codemirror/mode/markdown/markdown");
// Addons
require("codemirror/addon/mode/overlay");
require("codemirror/addon/fold/xml-fold");
require("codemirror/addon/fold/foldcode");
require("codemirror/addon/fold/foldgutter");
require("codemirror/addon/fold/brace-fold");
require("codemirror/addon/fold/xml-fold");
require("codemirror/addon/fold/indent-fold");
require("codemirror/addon/fold/comment-fold");
require("codemirror/addon/edit/matchbrackets");
require("codemirror/addon/edit/matchtags");
require("codemirror/addon/edit/closebrackets");
require("codemirror/addon/edit/closetag");
require("codemirror/addon/display/autorefresh");
require("codemirror/addon/lint/lint");
require("codemirror/addon/lint/json-lint");
require("codemirror/addon/display/placeholder");
require("codemirror/addon/hint/show-hint");
require("codemirror/addon/hint/anyword-hint");
CodeMirror.defineMode("text/html+mustache", function (config, parserConfig) {
    var mustacheOverlay = {
        token: function token(stream, state) {
            if (stream.match("{{")) {
                var ch = void 0;
                while ((ch = stream.next()) != null) {
                    if (ch == "}" && stream.next() == "}") {
                        stream.eat("}");
                        return "mustache";
                    }
                }
            }
            while (stream.next() != null && !stream.match("{{", false)) {}
            return null;
        }
    };
    return CodeMirror.overlayMode(CodeMirror.getMode(config, parserConfig.backdrop || "text/html"), mustacheOverlay);
});
// Code mirror defaults
CodeMirror.defaults = {
    lineNumbers: true,
    matchTags: true,
    gutters: ["CodeMirror-lint-markers", "CodeMirror-linenumbers", "CodeMirror-foldgutter"],
    lint: true,
    matchBrackets: true,
    autoCloseBrackets: true,
    foldGutter: true,
    autoRefresh: true,
    extraKeys: {
        'Tab': "emmetExpandAbbreviation",
        'Enter': "emmetInsertLineBreak",
        "Ctrl-Q": function CtrlQ(cm) {
            cm.foldCode(cm.getCursor());
        }
    }
};
$.fn.codeMirror = function () {
    var $this = $(this);
    $this.find(".codemirror").each(function () {
        var $me = $(this);
        var opts = __assign({}, CodeMirror.defaults);
        opts.mode = $me.data("mode");
        opts.readOnly = $me.data("readonly");
        var ed = CodeMirror.fromTextArea($me[0], opts);
        ed.refresh();
        ed.setSize(null, $me.data("height") || 500);
        $me.removeClass("codemirror").addClass("codemirror-ready");
        var height = $me.data("height");
        if (height) {
            $(ed.getWrapperElement()).height(height);
        }
        $me.data("codemirror", ed);
        $me.data("emmet-editor", ed);
    });
    return $this;
};
$(function () {
    $("body").codeMirror();
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/UI/sourcecode.ts
// module id = 460
// module chunks = 0